import { sortBy } from "lodash";
import React, { useContext, useMemo } from "react";
import styled from "styled-components";

import { getAlignmentsSafely } from "@examspark/api";
import { Button, Toolbar, VSpace } from "@examspark/common-ui";
import { PaddedBody } from "@examspark/common-ui/dist/components/modals/Modal";
import { Objective } from "@examspark/types";

import { useAppContext } from "../../../providers/AppContext";
import { ExamEditorContext } from "../../exam-editor/examEditor";

const StyledForm = styled.div`
  max-width: 50rem;
  margin: 0 auto;
  padding: 3rem;
`;

const StyledCard = styled.div`
  border: solid 1px #ddd;
  padding: 1rem;
  display: flex;
  gap: 1rem;
  cursor: pointer;
  border-radius: 0.5rem;
  transition:
    background-color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  box-shadow: none;

  &:hover {
    background-color: #f7f7f7;
    border-color: #ccc;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 5px;
  }
`;
const StyledCardInput = styled.div``;
const StyledCardBody = styled.div``;

const StyledTitle = styled.h3`
  margin: 0;
  font-weight: bold;
  color: #333;
  font-size: 1.4rem;
  font-weight: 500;
`;
const StyledSubtitle = styled.h4`
  margin: 0;
  font-weight: normal;
  color: #777;
`;

const StyledObjectiveContent = styled.div`
  color: #555;
`;

const ActivityEditorObjectives = () => {
  const [state, dispatch] = useContext(ExamEditorContext);
  const [appState] = useAppContext();

  const objectiveAuthorityIds = appState.userPrefs?.objectiveAuthorityIds;

  const allItemObjectives = useMemo(() => {
    const items: Objective[] = [];
    for (const question of state.questions) {
      for (const alignment of getAlignmentsSafely(question.alignments)) {
        if (
          objectiveAuthorityIds?.length &&
          !objectiveAuthorityIds.includes(alignment.authorityId ?? "__EMPTY__")
        ) {
          continue;
        }

        if (!items.some((item) => item.id === alignment.id)) {
          items.push(alignment);
        }
      }
    }

    return sortBy(items, ["scope", "sequence"]);
  }, [objectiveAuthorityIds, state.questions]);

  return (
    <PaddedBody>
      <StyledForm>
        <VSpace size="1rem">
          <VSpace size="0.5rem">
            <StyledTitle>Learning Standards</StyledTitle>
            <StyledSubtitle>
              Select the Learning Standards you would like to measure in this
              assessment.
            </StyledSubtitle>
          </VSpace>
          <Toolbar>
            <Button
              title="select"
              disabled={!allItemObjectives.length}
              onClick={() =>
                dispatch({
                  type: "ADD_OBJECTIVES",
                  objectives: allItemObjectives,
                })
              }
            >
              Select All
            </Button>
            <Button
              title="select"
              disabled={!allItemObjectives.length}
              onClick={() =>
                dispatch({
                  type: "CLEAR_OBJECTIVES",
                })
              }
            >
              Select None
            </Button>
          </Toolbar>
          <VSpace size="0.7rem">
            {!allItemObjectives.length && (
              <div>
                Add items to your assessment before selecting Objectives to
                report.
              </div>
            )}
            {allItemObjectives.map((objective) => {
              return (
                <StyledCard
                  key={objective.id}
                  onClick={() => {
                    dispatch({
                      type: "TOGGLE_OBJECTIVE",
                      objective: {
                        sequence: 0,
                        id: objective.id,
                        sk: "standard",
                        type: "objective",
                        abbreviation: objective.abbreviation ?? "",
                        content: objective.content ?? "",
                      },
                    });
                  }}
                >
                  <StyledCardInput>
                    <input
                      type="checkbox"
                      checked={
                        state.objectives.find((o) => o.id === objective.id) !==
                        undefined
                      }
                      // onChange={(e) =>
                      //   dispatch({
                      //     type: e.target.checked
                      //       ? "ADD_OBJECTIVE"
                      //       : "REMOVE_OBJECTIVE",
                      //     data: objective,
                      //   })
                      // }
                    />
                  </StyledCardInput>
                  <StyledCardBody>
                    <VSpace size="0.5rem">
                      <div>{objective.abbreviation}</div>
                      {!!objective.content && (
                        <StyledObjectiveContent>
                          {objective.content}
                        </StyledObjectiveContent>
                      )}
                      {/* <div>{objective.scope}</div> */}
                    </VSpace>
                  </StyledCardBody>
                </StyledCard>
              );
            })}
          </VSpace>
        </VSpace>
      </StyledForm>
    </PaddedBody>
  );
};

export default ActivityEditorObjectives;
